import type { ProjectWording } from "../types";

export const projectWordings: ProjectWording[] = [
  {
    id: "one-sentence-ru",
    title: "В одном предложении",
    format: "one-line",
    language: "ru",
    text: "Social by AKFA — крупный социальный диагностический и амбулаторный медицинский центр, создаваемый в Ташкенте для развития доступной и современной медицинской помощи в Узбекистане.",
    status: "approved",
    audience: "Универсальная аудитория",
    usageNote: "Для краткого представления проекта.",
    lastUpdatedAt: "2026-07-15",
  },
  {
    id: "short-description-ru",
    title: "Короткое описание",
    format: "short-description",
    language: "ru",
    text: "Social by AKFA объединяет современную диагностику, амбулаторную медицинскую помощь, цифровые сервисы и пациент-ориентированный подход.",
    status: "approved",
    audience: "Широкая аудитория",
    usageNote: "Для вводного абзаца, карточки или подписи.",
    lastUpdatedAt: "2026-07-15",
  },
  {
    id: "full-description-ru",
    title: "Расширенное описание",
    format: "full-description",
    language: "ru",
    text: "Social by AKFA — крупный социальный диагностический и амбулаторный медицинский центр, создаваемый в Ташкенте для развития доступной и современной медицинской помощи в Узбекистане. Проект ориентирован на оказание первичной медицинской помощи с использованием современных диагностических технологий, цифровых сервисов, единых стандартов работы и пациент-ориентированного подхода.",
    status: "approved",
    audience: "Партнёры, СМИ и профессиональное сообщество",
    usageNote: "Для презентаций, справок и вводных материалов.",
    lastUpdatedAt: "2026-07-15",
  },
  {
    id: "social-media-ru",
    title: "Для социальных сетей",
    format: "social-media",
    language: "ru",
    text: "Social by AKFA — проект, в котором современная медицина начинается с внимания к человеку. Мы создаём среду, где диагностика, профилактика, цифровые технологии и профессиональная работа медицинской команды объединяются вокруг потребностей пациента.",
    status: "approved",
    audience: "Подписчики социальных сетей",
    usageNote: "Упрощённый эмоциональный вариант без неподтверждённых обещаний.",
    lastUpdatedAt: "2026-07-15",
  },
  {
    id: "presentation-ru",
    title: "Для презентации",
    format: "presentation",
    language: "ru",
    text: "Social by AKFA создаёт новую модель организации масштабной амбулаторной и диагностической медицинской помощи, объединяя современные технологии, клинические стандарты, цифровые решения и подготовку медицинских специалистов.",
    status: "needs-review",
    audience: "Партнёры и профессиональное сообщество",
    usageNote: "Перед внешним использованием проверить актуальность описания модели.",
    lastUpdatedAt: "2026-07-15",
  },
  {
    id: "recruitment-ru",
    title: "Для материалов о найме",
    format: "recruitment",
    language: "ru",
    text: "Social by AKFA формирует команду врачей, готовых работать по единым профессиональным стандартам, клинически мыслить, эффективно взаимодействовать с пациентами и принимать решения в условиях, приближённых к реальной медицинской практике.",
    status: "approved",
    audience: "Врачи и медицинские специалисты",
    usageNote: "Для вакансий и материалов о профессиональном отборе.",
    lastUpdatedAt: "2026-07-15",
  },
  {
    id: "sps-ru",
    title: "Для описания SPS",
    format: "internal",
    language: "ru",
    text: "SPS — это практическая симуляция, которая помогает оценить клиническое мышление, профессиональные навыки, коммуникацию с пациентом и готовность врача работать в условиях реального приёма.",
    status: "needs-review",
    audience: "Кандидаты и медицинское сообщество",
    usageNote: "Проверить расшифровку аббревиатуры и детали процедуры перед официальной публикацией.",
    lastUpdatedAt: "2026-07-15",
  },
];

export const recommendedWords = [
  "доступная медицинская помощь",
  "современная диагностика",
  "пациент-ориентированный подход",
  "первичная медицинская помощь",
  "амбулаторная помощь",
  "единые стандарты",
  "цифровые сервисы",
  "профилактическая медицина",
  "клиническое мышление",
  "медицинская команда",
  "patient flow",
  "практическая симуляция",
];

export const cautionPhrases = [
  "первая клиника в Узбекистане",
  "крупнейшая клиника",
  "полностью бесплатные услуги",
  "лучшая медицина",
  "уникальный проект",
  "международный уровень",
  "гарантированный результат",
  "бесплатное лечение для всех",
  "открытие в конкретную дату",
  "точное число ежедневных пациентов",
];

export const prohibitedGuidance = [
  "Использовать неподтверждённые медицинские обещания.",
  "Гарантировать результат лечения.",
  "Называть услуги бесплатными без актуального подтверждения.",
  "Публиковать точные сроки запуска без согласованной информации.",
  "Использовать устаревшие цифры.",
  "Смешивать Social by AKFA и AKFA Medline как один и тот же бренд.",
  "Придумывать направления, услуги или партнёров.",
  "Использовать слишком рекламные формулировки без фактического основания.",
];
